<template>
  <div class="table-responsive">
    <b-table hover class="text-nowrap" v-if="items?.length > 0 && !isProcessing" :items="items" :fields="fields">
      <template #head(select)>
        <b-form-checkbox v-model="selectAll" @change="toggleSelectAll" aria-label="Select All"></b-form-checkbox>
      </template>
      <template #cell(select)="data">
        <b-form-checkbox v-model="data.item.selected" @change="toggleRowSelection(data.item)"></b-form-checkbox>
      </template>
      <template #cell(avatar_with_title)="data">
        <div class="d-flex align-items-center gap-2">
          <img v-if="data.item.oflMember === 'is_member' || data.item.oflMember == 1" src="@/assets/images/Union.png"
            alt="Membership Status" class="dashboard-avatar " />
          <img :src="data.item.avatar ? data.item.avatar : require('@/assets/images/users/default_user_image.png')" alt="Avatar"
            :class="['dashboard-avatar', 'me-2', avatarStyle]" @error="handleImageError" />

          <router-link :to="editUrl ? { name: editUrl,params:{id: data.item.id }} : '#'"
            class="cursor-pointer text-muted">
            {{ data.item.name }}
          </router-link>

        </div>
      </template>
      <template #cell(gifted_by_with_avatar)="data">
        <div class="d-flex align-items-center gap-2">
          <img :src="data.item.gifted_by_avatar
            ? data.item.gifted_by_avatar
            : require('@/assets/images/users/default_user_image.png')" alt="Avatar" class="dashboard-avatar me-2"
            @error="handleImageError" />

          <span class="text-muted">
            {{ data.item.gifted_by_name }}
          </span>
        </div>
      </template>

      <template #cell(gifted_user_with_avatar)="data">
        <div class="d-flex align-items-center gap-2">
          <template v-if="data.item.gifted_user_name">
          <img :src="data.item.gifted_user_avatar
            ? data.item.gifted_user_avatar
            : require('@/assets/images/users/default_user_image.png')" alt="Avatar" class="dashboard-avatar me-2"
            @error="handleImageError" />

          <span class="text-muted">
            {{ data.item.gifted_user_name }}
          </span>
          </template>
          <template v-else>
            None
          </template>
        </div>
      </template>
      
      <template #cell(social_links)="data">
        <div>
          <a v-for="(item, index) in data.item.social_links" :key="index" :href="item?.social_media_url"
            target="_blank">
            <img v-if="getSocialImage(item.social_media_type)" :src="getSocialImage(item.social_media_type)"
              class="Social-link me-2 cursor-pointer" alt="Social Media Icon" />
          </a>
        </div>
      </template>
      <template #cell(archive)="data">
        <div class="d-flex justify-content-center" v-if="showArchiveButton">
          <label class="toggle-switch">
            <input 
              type="checkbox"
              :checked="data.item.is_archive"
              @change="toggleArchive($event,data.item)"
            >
            <span class="toggle-slider"></span>
          </label>
        </div>
      </template>
      <template #cell(action)="data">
        <div class="d-flex">
          <template v-if="showActionButton">
            <i v-if="showEditButton" class="text-muted p-0 ms-2 far fa-edit action-icon-weight cursor-pointer"
              @click="$emit('editItem', data.item.id)"></i>
            <i v-if="showDeleteButton" class="text-muted p-0 ms-2 fas fa-trash-alt action-icon-weight cursor-pointer"
              @click="$emit('deleteItem', data.item.id)"></i>
          </template>
          <i v-if="showEyeButton" class="text-muted p-0 ms-2 fas fa-eye action-icon-weight cursor-pointer"
            @click="$emit('showItem', data.item.id)"></i>
          <i v-if="showReactivateButton" title="Reactivate User" class="text-muted p-0 ms-2 fa-solid fa-clock-rotate-left cursor-pointer"
            @click="$emit('restoreActivateUser', data.item.id)"></i>
          <i v-if="showHardDeletedButton" title="Permanently Delete" class="text-danger p-0 ms-2 fas fa-trash-alt cursor-pointer"
            @click="$emit('hardDeleteItem', data.item.id)"></i>
          <i v-if="showRestoreUserButton" title="Restore User" class="text-success p-0 ms-2 fas fa-trash-restore cursor-pointer"
            @click="$emit('restoreUser', data.item.id)"></i>   
        </div>
      </template>

      <template #cell(make_default)="data">
        <div class="d-flex justify-content-start">
          <label class="toggle-switch">
            <input 
              type="checkbox"
              :checked="data.item.is_default"
              @change="$emit('makeDefault', data.item.id)"
            >
            <span class="toggle-slider"></span>
          </label>
        </div>
      </template>

      <template #cell(custom_cell)>
        <slot name='custom-option'>

        </slot>
      </template>


    </b-table>

    <div v-else class="text-center">

      <span v-if="!isProcessing && items?.length < 1">No Record Found</span>
      <div v-else>
        <i class="fas fa-spinner fa-spin"></i>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    fields: {
      type : Array,
      required: true,
    },
    isProcessing: {
     type: Boolean,
     default: false,

    },
    avatarStyle: {
    type: String,
    default:'',
    },
    editUrl:{
      type: String,
      default:'',
    },
    showEyeButton: {
      type: Boolean,
      default: false, 
    },
    showActionButton: {
      type: Boolean,
      default: true,
    },
    showArchiveButton: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },
    showEditButton: {
      type: Boolean,
      default: true,
    },
    showReactivateButton: {
      type: Boolean,
      default: false,
    },
    showHardDeletedButton: {
      type: Boolean,
      default: false,
    },
    showRestoreUserButton: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      selectAll: false,
      selectedRows: [], 
      isArchived: false,
    };
  },
  computed: {
    itemsWithSelection() {
      return this.items.map(item => ({ ...item, selected: false }));
    },
  
  },
watch: {
 items(newValue) {
      if (!this.isProcessing && newValue?.length < 1) {
        this.handleNoRecords();
      }
    },
  },
  methods: {
    handleNoRecords() {
      this.$emit("no-records-found");
    },
    getSocialImage(key) {
      if (!key) return ; 
      key = key.trim().toLowerCase(); 
      switch (key) {
        case 'facebook':
          return require('@/assets/images/fb.png'); 
        case 'instagram':
          return require('@/assets/images/insta.png');
        case 'twitter':
          return require('@/assets/images/x.png');
        // case 'google':
        //   return require('@/assets/images/yelp.png');
        default:
          return ;
      }
    },
    toggleSelectAll() {
      this.items.forEach(item => (item.selected = this.selectAll));
      this.updateSelectedRows();
    },
    toggleRowSelection(item) {
      if (item.selected) {
        this.selectedRows.push(item);
      } else {
        this.selectedRows = this.selectedRows.filter(selected => selected.email !== item.email);
      }
      this.$emit("update:selectedRows", this.selectedRows.map(item=>item.id));
    },
    updateSelectedRows() {
       if (this.selectAll) {
        this.items = this.items.map(item => ({ ...item, selected: true }));
        this.selectedRows= this.items;
      }
      else
      {
       this.items = this.items.map(item => ({ ...item, selected: false }));
       this.selectedRows= [];
      }
      this.$emit("update:selectedRows", this.selectedRows.map(item=>item.id));

      this.$emit("selected-rows-updated", {
        ids: this.selectedRows.map(item => item.id),
        items: this.selectedRows
      });
    },
    handleImageError(event) {
      event.target.src = require('@/assets/images/users/default_user_image.png');
    },
  
    async toggleArchive(event, item) {
      const checked = event.target.checked;
      this.$emit('archiveItem', { id: item.id, is_archive: checked });
    },
  }
};
</script>

<style>
.remove-chevron.dropdown-toggle::after {
  display: none !important;
}

/* Toggle Switch Styles */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin: 0;
  vertical-align: middle;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .3s;
  border-radius: 20px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .3s;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0,0,0,0.2);
}

input:checked + .toggle-slider {
  background-color: #EC421C;
}

input:focus + .toggle-slider {
  box-shadow: 0 0 0 2px rgba(236, 66, 28, 0.25);
}

input:checked + .toggle-slider:before {
  transform: translateX(20px);
}
</style>
